import { forwardRef } from 'react';
import { Box, Link, Stack, Typography } from '@lingoda/ui';
import { GlobeSimpleIcon } from '@lingoda/ui/icons/lingodaIcons';
import { trans } from '@lingoda/i18n';
import { type Path } from '@lingoda/router';
import { NotificationBar } from './NotificationBar';

interface Props {
    settingsPath: Path;
    onDismiss?: () => void;
}

export const TimezoneDifferencesBar = forwardRef<HTMLDivElement, Props>(
    ({ settingsPath, onDismiss }, ref) => {
        return (
            <NotificationBar
                ref={ref}
                severity="warn"
                icon={<GlobeSimpleIcon size={24} />}
                onDismiss={onDismiss}
            >
                <Stack direction="row" flexWrap="wrap" gap={1}>
                    <Box mr={1}>
                        <Typography
                            variant="subtitle1"
                            sx={{ color: (theme) => theme.colors.text.warning }}
                        >
                            {trans('timezone-shift-detected', {}, 'alerts-common+intl-icu')}
                        </Typography>
                    </Box>

                    <Link to={settingsPath}>
                        {trans('sync-my-timezone', {}, 'alerts-common+intl-icu')}
                    </Link>
                </Stack>
            </NotificationBar>
        );
    },
);

TimezoneDifferencesBar.displayName = 'TimezoneDifferencesBar';
